import { render, staticRenderFns } from "./OperationDetails.vue?vue&type=template&id=345b5c20&scoped=true&"
import script from "./OperationDetails.vue?vue&type=script&lang=js&"
export * from "./OperationDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "345b5c20",
  null
  
)

export default component.exports